/**
 * return true in node environment false if not
 */
export function isNode() {
    return Object.prototype.toString.call(global.process) === '[object process]';
}
export function isInNodeEnv(param) {
    return process.env.NODE_ENV === param;
}
export function isInLocalStorage(key, param) {
    const value = localStorage.getItem(key);
    return typeof value === 'string' && value.startsWith(param);
}
export function isDev() {
    if (isNode()) {
        return !isInNodeEnv('production');
    }
    return isInLocalStorage('debug', 'canopy');
}
export function isTest() {
    if (isNode()) {
        return isInNodeEnv('test');
    }
    return isInLocalStorage('test', 'test');
}
// https://medium.com/@david.gilbertson/the-only-way-to-detect-touch-with-javascript-7791a3346685
export function isTouchable() {
    if (isNode()) {
        return false;
    }
    try {
        document.createEvent('TouchEvent');
        return true;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (e) {
        return false;
    }
}
export function getTimeout() {
    var _a;
    if (isNode()) {
        return {
            default: Number(process.env.TIMEOUT_DEFAULT) || 2000,
            long: Number(process.env.TIMEOUT_LONG) || 5000,
            cdn: Number(process.env.TIMEOUT_CDN) || 1000,
        };
    }
    return ((_a = window.API_MANIFEST) === null || _a === void 0 ? void 0 : _a.timeout) || { default: 2000, long: 5000, cdn: 1000 };
}
export function getTimeoutDefault() {
    return getTimeout().default;
}
export function getTimeoutCdn() {
    return getTimeout().cdn;
}
export function getTimeoutLong() {
    return getTimeout().long;
}
export function cdnUrl() {
    var _a;
    let cdn;
    if (isNode()) {
        cdn = process.env.CDN || '/';
    }
    else {
        cdn = ((_a = window.API_MANIFEST) === null || _a === void 0 ? void 0 : _a.cdn) || '/';
    }
    if (!cdn.endsWith('/')) {
        cdn = `${cdn}/`;
    }
    return cdn;
}
export function cdnImagesUrl() {
    var _a;
    let cdnImages;
    if (isNode()) {
        cdnImages = process.env.CDN_IMAGES || '/';
    }
    else {
        cdnImages = ((_a = window.API_MANIFEST) === null || _a === void 0 ? void 0 : _a.cdnImages) || '/';
    }
    if (!cdnImages.endsWith('/')) {
        cdnImages = `${cdnImages}/`;
    }
    return cdnImages;
}
export function mockCdnImages(cdnImages) {
    if (!isNode()) {
        window.API_MANIFEST = Object.assign(Object.assign({}, window.API_MANIFEST), { cdnImages });
        return cdnImages;
    }
    return cdnImagesUrl();
}
